'use client';

import { createContext, useContext } from 'react';
import useAbsDeals from '@/creditflowresearch/application/Deal/contexts/IssueTile/useAbsDeals';

type AbsContextType = ReturnType<typeof useAbsDeals>;

export const AbsContext = createContext<AbsContextType>(null);

export const useAbsContext = () => {
  const context = useContext(AbsContext);
  if (!context) {
    throw new Error('useAbsContext must be used within the AbsContext');
  }
  return context;
};

const ABSContextProvider = ({ children, deals, fetch, additionalFilters }) => {
  const value = useAbsDeals({
    deals,
    fetch,
    additionalFilters,
  });

  return (
    <AbsContext.Provider value={ value }>
      { children }
    </AbsContext.Provider>
  );
};

export default ABSContextProvider;
